import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import ForgotPasswordComp from '../components/forgotPasswordComp';
import LoginImageComp from '../components/image/loginImageComp';
import LoginComp from '../components/loginComp';
import { resetPasswordRequest } from '../modals';
import { getUserInfo, login } from '../modals/user';
import JSEncrypt from 'jsencrypt';

const UserLogin = ({ updateLoginStatus, sessionTimer }) => {
  const location = useLocation();
  const history = useHistory();
  const token = new URLSearchParams(location.search).get('token');

  const [isLoading, setIsLoading] = useState(token ? true : false);
  const [pswResetMailSending, setPswResetMailSending] = useState(false);

  const [errorResponse, setErrorResponse] = useState();
  const [resetEmailStatus, setResetEmailStatus] = useState({});

  const forgotPassword = async (email) => {
    setPswResetMailSending(true);
    try {
      const result = await resetPasswordRequest(email);
      setPswResetMailSending(false);
      result['Status '] === ' success' &&
        setResetEmailStatus({ email, status: true, message: '' });
    } catch (error) {
      console.log('reset email ', error);
      setPswResetMailSending(false);
      setResetEmailStatus({
        status: false,
        message: error?.message ? error.message : 'Network Error!',
      });
      setTimeout(() => {
        setResetEmailStatus({});
      }, 5000);
    }
  };

  const loginUser = async (data) => {
    setIsLoading(true);
    try {
      const encrypt = new JSEncrypt();
      const publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgxjsh20XBsClnjywb+cTAX2uhV/dD6t8YvTcw1OFMdmvEuckpyvcXM9WE4VLI8xcYexdxem01/Z9jJN7T7QuI2dPUfR2k/6/+OFVSC8dv7/DKSmO5eoaEQCnVmQNJ1nRcSNpQ+xdJkXTjzQmOR+Kl8DXjV6ua2KrshtJojRi/JdbB+WMajfeglSfmU9nN6HAy/o4alrai6qTQNX4MR1mqBCjNGc8Dtr6zK/wp8YFyyh+oaydxmxAo+wQEWqlrN3sSbzwYwQPMBJ+LdfpWCu0R5ev/uvp+R1dPe1uKbqQjMhiNAmpIfQeuZwaXwUnVOQ7Gm/q0sSFfyNYO+Adb5fdYwIDAQAB'
      encrypt.setPublicKey(publicKey);
      const encrypted = encrypt.encrypt(data.password);
      data.password = encrypted;
      const result = await login(data);
      const { userRoles = [] } = result;
      result.schoolId = userRoles.find((r) => r.roleId === 3 && r.schoolId)?.schoolId || userRoles.find((r) => r.roleId === 3)?.schoolId || '';
      if (result.roleId !== 3 && !(userRoles.some(role => role.roleId === 3))) {
        setErrorResponse('Please use counsellor Id to login. ');
        updateLoginStatus(false);
        setIsLoading(false);
        setTimeout(() => {
          setErrorResponse('');
        }, 5000);
        return;
      }

      updateLoginStatus(true);
      localStorage.setItem('logintoken', result.token);
      localStorage.setItem('userinfo', JSON.stringify(result));
      const time = Math.round(new Date().getTime() / 1000);
      localStorage.setItem('loginTime', time + 3300);
      localStorage.setItem('tokenRefreshTime', time + 1800);
      setErrorResponse('');
      sessionTimer();
      history.push('home');
    } catch (error) {
      setIsLoading(false);
      setErrorResponse(error?.message || 'Network Error');
      updateLoginStatus(false);
      console.log('userLogin', error);
      setTimeout(() => {
        setErrorResponse('');
      }, 10000);
    }
  };

  useEffect(() => {
    if (localStorage.getItem('logintoken')) {
      history.push('home');
      return;
    }
    history.listen((location, action) => {
      if (location.pathname === '/login') {
        setResetEmailStatus({ status: false, message: '' });
        console.log('histry.listen userlogin page');
        return;
      }
    });
  }, []);
  const getInfo = async () => {
    try {
      // localStorage.setItem('logintoken', token);
      const res = await getUserInfo(token);
      console.log('get user info after sso login', res);
      setIsLoading(false);
      localStorage.setItem('logintoken', res.token);
      localStorage.setItem('userinfo', JSON.stringify(res));
      updateLoginStatus(true);
      const time = Math.round(new Date().getTime() / 1000);
      localStorage.setItem('loginTime', time + 3300);
      localStorage.setItem('tokenRefreshTime', time + 1800);
      setErrorResponse('');
      sessionTimer();
      history.push('home');
    } catch (error) {
      setIsLoading(false);

    }
  }
  useEffect(() => {

    if (token) {
      getInfo();
    }

  }, [token])
  if (localStorage.getItem('userinfo')) {
    return <></>;
  }
  return (
    <>
      <div className="pico-contentWrapper">
        <div className="pico-container flexcontainer">
          <LoginImageComp />
          <div className="pico-formwrapper">
            {resetEmailStatus.status ? (
              <ForgotPasswordComp email={resetEmailStatus.email} />
            ) : (
              <LoginComp
                title1={location.title1 || 'Log In'}
                title2={location.title2}
                loginFunction={loginUser}
                errorResponse={errorResponse}
                forgotPassword={forgotPassword}
                resetEmailStatus={resetEmailStatus}
                isLoading={isLoading}
                pswResetMailSending={pswResetMailSending}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default UserLogin;
